import React from 'react';
import { Tabs } from 'antd';
import {
  LinkOutlined,
  WarningOutlined,
  MedicineBoxOutlined,
  UserOutlined,
  CopyOutlined,
} from '@ant-design/icons';
import GcPagina from '../components/Layout/GcPagina';
import { FctTarjeta } from '../fct/react';
import VinculacionResumenTab from '../components/VinculacionCU2/VinculacionResumenTab';
import VinculacionIncoherenciasTab from '../components/VinculacionCU2/VinculacionIncoherenciasTab';
import VinculacionFarmaciasCU2SinVincularTab from '../components/VinculacionCU2/VinculacionFarmaciasCU2SinVincularTab';
import VinculacionFarmaciasSinVincularTab from '../components/VinculacionCU2/VinculacionFarmaciasSinVincularTab';
import VinculacionTitularesSinVincularTab from '../components/VinculacionCU2/VinculacionTitularesSinVincularTab';
import VinculacionFarmaciasDuplicadasTab from '../components/VinculacionCU2/VinculacionFarmaciasDuplicadasTab';

/**
 * Vinculación CU2 — panel portado del panel Python (VinculacionCU2-AQ).
 * 4 pestañas: Vinculación (resumen), Incoherencias, Farmacias Gescom sin vincular,
 * Titulares Gescom sin vincular. Acceso con permiso GCvsc.Reconciliacion.Read.
 */
const VinculacionCU2Page: React.FC = () => {
  const items = [
    {
      key: 'vinculacion',
      label: (
        <span>
          <LinkOutlined /> Vinculación
        </span>
      ),
      children: <VinculacionResumenTab />,
    },
    {
      key: 'incoherencias',
      label: (
        <span>
          <WarningOutlined /> Incoherencias
        </span>
      ),
      children: <VinculacionIncoherenciasTab />,
    },
    {
      key: 'farmacias-cu2-sv',
      label: (
        <span>
          <MedicineBoxOutlined /> Farmacias CU2 sin vincular
        </span>
      ),
      children: <VinculacionFarmaciasCU2SinVincularTab />,
    },
    {
      key: 'farmacias-sv',
      label: (
        <span>
          <MedicineBoxOutlined /> Farmacias Gescom sin vincular
        </span>
      ),
      children: <VinculacionFarmaciasSinVincularTab />,
    },
    {
      key: 'titulares-sv',
      label: (
        <span>
          <UserOutlined /> Titulares Gescom sin vincular
        </span>
      ),
      children: <VinculacionTitularesSinVincularTab />,
    },
    {
      key: 'duplicadas-cu2',
      label: (
        <span>
          <CopyOutlined /> Farmacias duplicadas en CU2
        </span>
      ),
      children: <VinculacionFarmaciasDuplicadasTab />,
    },
  ];

  return (
    <GcPagina
      seccion="Vinculación CU2"
      titulo="Vinculación CU2 y Gescom"
      contexto="Panel de vinculación CU2-Gescom"
      densidad="compacta"
    >
      <FctTarjeta>
        <Tabs defaultActiveKey="vinculacion" items={items} />
      </FctTarjeta>
    </GcPagina>
  );
};

export default VinculacionCU2Page;
